import { useEffect, useState } from "react";
import chiikiCsvUrl from "../assets/csv/chiiki_kubun.csv";
import keikaCsvUrl from "../assets/csv/chiiki_kubun_keikasochi.csv";
import { createChiikiContext } from "./logic";
import { loadAllChiikiCsv } from "../lib/csvLoader";

export function useChiikiCsvData() {
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    let ignore = false;

    async function init() {
      try {
        const { chiikiRows, keikaRows } = await loadAllChiikiCsv({
          chiikiCsvUrl,
          keikaCsvUrl,
        });
        if (!ignore) {
          setContext(createChiikiContext(chiikiRows, keikaRows));
        }
      } catch (error) {
        if (!ignore) {
          setLoadError(error.message);
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    }

    init();
    return () => {
      ignore = true;
    };
  }, []);

  return { context, loading, loadError };
}
